import { TActions } from '../../../../AppModulesWrapper';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../../actions/publishTerms';
import { CHANGE_AUTO_PROLONG } from '../../../actions/checkoutInfo';
import { IPaidPublicationState } from './types';

const defaultState: IPaidPublicationState = {
  days: 0,
  autoProlong: false,
  highDemandCoefficient: 0,
  isEdit: 'edit',
  isPaid: false,
  moderation: {
    isAllowed: true,
    unavailableReasonType: null,
  },
  price: 0,
  token: '',
};

export const paidPublication = (state: IPaidPublicationState = defaultState, action: TActions) => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return {
        ...state,
        ...action.payload.dataV2.paidPublication,
      };
    }
    case CHANGE_AUTO_PROLONG: {
      return {
        ...state,
        autoProlong: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
